module.exports = __webpack_public_path__ + "img/header-engagementRingsCordial.760604a.webp";